import { Link as ScrollLink } from 'react-scroll';
import { Link, useNavigate } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

import logo from '../moodmealslogo.png';
import facebook from "../assets/icons/Facebook.png";
import instagram from "../assets/icons/Instagram.png";
import twitter from "../assets/icons/TwitterX.png";
import back from "../assets/icons/back-arrow.png"
import user1 from "../assets/icons/User.png";

import '../styles/CartPage.css';

const CartPage=({user,setOrderSummary,onLogout,logoutSuccess,setLogoutSuccess})=>{

  const [cart,setCart]=useState([]);
  // const [totalItems,setTotalItems]=useState(0);
  const [subTotal,setSubTotal]=useState(0);
  const [totalPrice,setTotalPrice]=useState(0);
  const [promoCode, setPromoCode] = useState('');
  const [holdpromoCode,setHoldPromoCode]=useState('');
  const [discount,setDiscount]=useState(0);
  const [tax,setTax]=useState(0);

  const [isLoading,setIsLoading]=useState(true);
  const [isDropdownOpen,setIsDropdownOpen]=useState(false);
  const navigate=useNavigate();
  const dropdownRef=useRef(null);

  useEffect(()=>{
    setTimeout(()=>{
      setIsLoading(false);
    },2000);
  },[]);
  
  useEffect(()=>{
    if(logoutSuccess){
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
            setLogoutSuccess(false);
            navigate('/');
        }, 2000);
    }
  },[logoutSuccess,navigate,setLogoutSuccess]);

  useEffect(()=>{
    axios.get(`/api/user/getCartItems`,{withCredentials:true})
    .then(res=>{
        setCart(res.data.cart);
    })
    .catch(err=>{
        console.error('No active session:',err);
    })
  },[]);

  const updateItem=(id,prodId,newQty)=>{
    if(newQty<=0) return;
    let prodCurrPrice,setPrice,newPrice;
    axios.get(`/api/getOneProduct/${prodId}`,{withCredentials:true})
    .then(res=>{
        prodCurrPrice=res.data.product.prod_price;
        setPrice=prodCurrPrice*newQty;
        newPrice=parseFloat(setPrice.toFixed(2));
        return axios.put(`/api/user/updateFromCart/${id}`,{cart_qty:newQty, cart_itemprice:newPrice },{withCredentials:true});
    })
    .then(res=>{
        setCart(cart.map(element=>element._id===id?{...element, cart_qty:newQty, cart_itemprice:newPrice}:element));
    })
    .catch(err=>{
        console.error('Something went wrong',err);
    });
  };

  const removeItem=(id)=>{
    axios.delete(`/api/user/removeFromCart/${id}`,{withCredentials:true})
    .then(res=>{
        setCart(cart.filter(item=>item._id!==id));
    })
    .catch(err => {
        console.error('Error removing cart item:', err);
    });
  };

  const applyPC=()=>{
    if (promoCode==='MOODBOOST') {
        setDiscount(154);
        setHoldPromoCode(promoCode);
        setPromoCode('');
    } else {
        setDiscount(0);
        alert('Invalid Promo Code');
    }
  };

  useEffect(()=>{
    const totalItems=cart.reduce((total,item)=>
      total+item.cart_qty,0
    );
    // setTotalItems(totalItems);
    const subTotal=cart.reduce((total,item)=>
      total+item.cart_itemprice,0
    );
    const newSubTotal=parseFloat(subTotal.toFixed(2));
    setSubTotal(newSubTotal);
    const tax=newSubTotal*0.12;
    const newTax=parseFloat(tax.toFixed(2));
    setTax(newTax);
    const totalPrice=subTotal+tax-discount;
    const newTotalPrice=parseFloat(totalPrice.toFixed(2));
    setTotalPrice(newTotalPrice);
    setOrderSummary({
      totalItems,
      totalPrice,
      subTotal,
      discount,
      holdpromoCode,
      tax
    })
  },[cart,discount,setOrderSummary,holdpromoCode]);

  const handleCheckout=(e)=>{
    e.preventDefault();
    navigate('/checkout')
  }

  const toggleUser=()=>{
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleClickOutside=(e)=>{
      if(dropdownRef.current&&!dropdownRef.current.contains(e.target)){
          setIsDropdownOpen(false);
      }
  };

  useEffect(()=>{
      document.addEventListener('mousedown',handleClickOutside);
      return()=>{
          document.removeEventListener('mousedown',handleClickOutside);
      };
  },[]);

  return (
    <>
      {isLoading?(
        <div className="loadingContainer">
            <img src={logo} alt="Loading..." className="moodmeals-loading-logo"/>
        </div>
      ):(
      <>
        {/* <!-- Cart Section --> */}
        <main className="cart-bg-wrapper">
          {/* <!-- Header Section --> */}
          <header className="cart-header">
            <div className="cart-back">
              <Link to="/"><img src={back} className="cart-back-btn" alt="Back"/> Back</Link>
            </div>
            <div className="user-profile">
              <div className="user-bg">
                <h5>{user.firstname} {user.lastname}</h5>
              </div>
              <div className="cartDropdown">
                <img src={user?user.avatar:user1} alt="#User Avatar" loading="lazy" onClick={toggleUser}/>
                {isDropdownOpen&&(
                    <div className="cart-dropdownMenu" ref={dropdownRef}>
                        {user?(
                            <>
                              <p className="cart-dropdownItem">Welcome, {user.firstname}</p>
                              <Link to="/profile" className="cart-dropdownItem">Profile</Link>
                              <Link to="/setting" className="cart-dropdownItem">Setting</Link>
                              <Link onClick={onLogout} className="cart-dropdownItem">Log Out</Link>
                            </>
                        ):(
                            <>
                              <Link to="/login" className="cart-dropdownItem">Login</Link>
                              <Link to="/register" className="cart-dropdownItem">Register</Link>
                            </>
                        )}
                    </div>
                )}
              </div>
            </div>
          </header>
          <main className="cart-main">
            <section className="your-cart">
              {cart.length?(
                <> 
                  <h1>Your Cart</h1>
                  <p>Review your mood-boosting meals before checkout.</p>
                  <section className="cart">
                    <section className="cart-lists">
                      {cart.map((element,index)=>(
                        <div className="cart-item">
                          <img src={element.cart_img} className="item-picture" alt={`Cart ${index}`}/>
                          <div className="item-info">
                            <div className="item-name">
                              <h3>{element.cart_name}</h3>
                            </div>
                            <div className="item-info2">
                              <div className="option-qty">
                                <p>{element.cart_boxsize}</p>
                                <p>{element.cart_dietpref}</p>
                                <p></p>
                                <div className="item-quantity">
                                  <button className="qty-btn" onClick={()=>updateItem(element._id, element.prod_Id, element.cart_qty-1)}>-</button>
                                  <input type="text" value={element.cart_qty} onChange={(e)=>updateItem(element._id, parseInt(e.target.value)||1)}/>
                                  <button className="qty-btn2" onClick={()=>updateItem(element._id, element.prod_Id, element.cart_qty+1)}>+</button>
                                </div>
                              </div>
                              <div className="price-delete">
                                <h1 className="price">₱ {element.cart_itemprice}</h1>
                                <button className="delete-btn" onClick={()=>removeItem(element._id)}>Delete</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      <Link to='/shop' className="continue-shopping">Continue Shopping</Link>
                    </section>
                    {/* <!-- Promo Code and Summary --> */}
                    <section className="cart-summary-wrapper">
                      <div className="promo-code">
                        <input type="text" placeholder="Enter Promo Code" value={promoCode} onChange={(e)=>setPromoCode(e.target.value)}/>
                        <button className="apply-btn" onClick={applyPC}>Apply</button>
                      </div>
                      <div className="order-summary">
                        <div className="os-total"> 
                          <h3>Total Order </h3>
                          <p className="total">₱ {totalPrice}</p>
                        </div>
                        <p>Subtotal: ₱ {subTotal}</p>
                        <p>Shipping: Free</p>
                        <p>Discounts: -₱ {discount} (Promo: {holdpromoCode})</p>
                        <p>Tax: ₱ {tax}</p>
                        <button className="checkout-btn" onClick={(e)=>handleCheckout(e)}>Proceed to Checkout</button>
                      </div>
                    </section>
                  </section>
                </>
              ):(
                <> 
                  <h1>Your cart is empty</h1>
                  <p>Looks like you haven't added anything to your cart yet.</p>
                  <section className="cart">
                    <section className="cart-lists">
                      <Link to='/shop' className="continue-shopping">Shop Now</Link>
                    </section>
                  </section>
                </>
              )}
            </section>
          </main>
        </main>
        {/* <!-- Footer Section --> */}
        <footer className="cart-footer">
          <h3 className="cart-get-in-touch">Get in Touch</h3>
          <div className="cart-footer-content">
              <div className="cart-footer-section">
                <h3>Customer Support</h3>
                <p>Email: <a href="/">support@moodmeals.com</a></p>
                <p>Phone: <a href="/">+63 (800) 123-4567</a></p>
                <p>Live Chat: Available Monday to Friday, 9 AM - 6 PM (EST)</p>
                <h3>General Inquiries:</h3>
                <p>For general questions, feedback, or press inquiries, please email: <a href="/">info@moodmeals.com</a></p>
                <h3>Partnership Opportunities:</h3>
                <p>Interested in partnering with MoodMeals? Reach out to: <a href="/">partnerships@moodmeals.com</a></p>
              </div>
              <div className="cart-footer-section">
                <h3>Quick Links</h3>
                <ul>
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/shop">Shop</Link></li>
                  <li><Link to={{pathname:"/",state:{section:"recipes"}}}>Recipes</Link></li>
                  <li><Link to={{pathname:"/",state:{section:"community"}}}>Community</Link></li>
                  <li><Link to={{pathname:"/",state:{section:"about-us"}}}>About Us</Link></li>
                  <li><ScrollLink to="contact" smooth={true} duration={500}>Contact</ScrollLink></li>
                  <li><Link to={{pathname:"/",state:{Element:"blog"}}}>Blog</Link></li>
                </ul>
              </div>
              <div className="cart-footer-section">
                <h3>Customer Services</h3>
                <ul>
                  <li><a href="#contact-us">Contact Us</a></li>
                  <li><a href="#faq">FAQ</a></li>
                  <li><a href="#shipping&returns">Shipping & Returns</a></li>
                  <li><a href="#terms&condition">Terms & Condition</a></li>
                  <li><a href="#privacy">Privacy Policy</a></li>
                </ul>
              </div>
          </div>
          <div className="cart-soc-med">
            <div className="cart-app-wrapper">
              <img className="app" src={facebook} alt="facebook"/>
              <img className="app" src={instagram} alt="instagram"/>
              <img className="app" src={twitter} alt="twitter"/>
              <p>Mailing Address: MoodMeals HQ 123 Wellness Lane, Healthy City, MA 10001, Philippines</p>
            </div>
            <div className="cart-copyright">
                <p>&copy; 2024 MoodMeals. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </>
      )}
    </>
  )
}

export default CartPage;